import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import "./app.css";
import { getImage } from "../../../../../utils/getImages";
import { useDataLayerValue } from "../../../../../DataLayer/DataLayer";

const getDateFormatByLang = (lang) => {
  switch (lang) {
    case "SC":
    case "TC":
      return "YYYY年MM月DD日";
    default:
      return "DD MMM YYYY";
  }
};

const formatDateRange = (value, lang) => {
  const [start, end] = Array.isArray(value) ? value : [];
  if (!start) return "";
  const format = getDateFormatByLang(lang);
  const formatDate = (d) => dayjs(d).locale("en").format(format);
  const startLabel = formatDate(start);
  if (!end || end === start) return startLabel;
  return `${startLabel} - ${formatDate(end)}`;
};

const MusicianCards = ({ cardData, activetab }) => {
  const [{ ships }] = useDataLayerValue();
  const [activeShip, setActiveShip] = useState("");

  const groups = (cardData?.dataArray || []).reduce((acc, item) => {
    const shipId = item?.ship || "";
    if (!acc[shipId]) acc[shipId] = [];
    acc[shipId].push(item);
    return acc;
  }, {});

  const shipIds = Object.keys(groups);

  useEffect(() => {
    if (!shipIds.includes(activeShip)) {
      setActiveShip(shipIds[0] || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardData]);

  return (
    <div style={{ marginLeft: "10px" }}>
      <h1 className="title-color mb-4" style={{ textAlign: "center" }}>
        {" "}
        {activetab === "english"
          ? cardData?.title
          : activetab === "simplified_chinese"
          ? cardData?.simplified_chinese_title
          : activetab === "arabic"
          ? cardData?.arabic_title
          : activetab === "bahasa"
          ? cardData?.bahasa_title
          : cardData?.traditional_chinese_title}
      </h1>

      <div
        className="col-12 text-center mb-5"
        style={{ display: "flex", alignItems: "center", width: "100%" }}
      >
        <ul
          className="page-tab scroll-tab"
          style={{
            display: "flex",
            gap: "10px",
            listStyleType: "none",
            padding: 0,
            alignItems: "center",
            justifyContent: "center",
            margin: 0,
            width: "100%",
          }}
        >
          {shipIds.map((shipId) => (
            <li
              key={shipId}
              onClick={() => setActiveShip(shipId)}
              style={{
                cursor: "pointer",
                fontWeight: shipId === activeShip ? "700" : "400",
                textDecoration: shipId === activeShip ? "underline" : "none",
              }}
            >
              {ships?.find((s) => s.id === shipId)?.name || shipId}
            </li>
          ))}
        </ul>
      </div>

      <div className="row" style={{ width: "100%" }}>
        {(groups[activeShip] || []).map((item) => {
          const lang =
            activetab === "english"
              ? "EN"
              : activetab === "simplified_chinese"
              ? "SC"
              : activetab === "traditional_chinese"
              ? "TC"
              : "Bahasa";
          const rawDate =
            activetab === "english"
              ? item?.date
              : activetab === "simplified_chinese"
              ? item?.simplified_chinese_date
              : activetab === "arabic"
              ? item?.arabic_date
              : activetab === "bahasa"
              ? item?.bahasa_date
              : item?.traditional_chinese_date;
          const dateLabel = formatDateRange(rawDate, lang);

          return (
            <div className="col-md-12" style={{ marginBottom: "10px" }}>
              <div className="event-holder">
                <a className="rounded gallery-item">
                  <img src={getImage(item?.image)} alt="" className="w-100" />
                  {dateLabel && (
                    <div
                      style={{
                        color: "#fff",
                        background: "#2a3989",
                        position: "absolute",
                        top: 0,
                        right: 0,
                        fontSize: "14px",
                        margin: 0,
                        padding: "11px 22px",
                        borderRadius: "0 5px",
                        zIndex: 10,
                      }}
                    >
                      {dateLabel}
                    </div>
                  )}
                  <div className="info">
                    <h3 className="title">
                      {activetab === "english"
                        ? item?.title
                        : activetab === "simplified_chinese"
                        ? item?.simplified_chinese_title
                        : activetab === "arabic"
                        ? item?.arabic_title
                        : activetab === "bahasa"
                        ? item?.bahasa_title
                        : item?.traditional_chinese_title}
                      <p
                        style={{
                          direction: activetab === "arabic" && "rtl",
                          maxHeight: "100px",
                          overflow: "hidden",
                          fontWeight: "400",
                          fontSize: "14px",
                          color: "white",
                        }}
                        dangerouslySetInnerHTML={{
                          __html:
                            activetab === "english"
                              ? item?.description
                              : activetab === "simplified_chinese"
                              ? item?.simplified_chinese_description
                              : activetab === "arabic"
                              ? item?.arabic_description
                              : activetab === "bahasa"
                              ? item?.bahasa_description
                              : item?.traditional_chinese_description,
                        }}
                      />
                    </h3>
                  </div>
                </a>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MusicianCards;
